/*
 * @Author: tianyuerong
 * @Date: 2021-11-19 17:25:08
 * @LastEditTime: 2021-11-22 10:16:21
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \select-oil-h5-v2\src\store\scenes.js
 */
export const transmissionScene = [
  "engine-oil-recommend",
  "transmission-oil-recommend",
  "category-select",
];
